import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";
import ChevronIcon from "assets/icons/chevron-left.svg";
import closeIcon from "assets/icons/close.svg";
import Button from "components/button/Button";
import {
  default as FinanceSetting,
} from "Lib/API/FinanceSetting/FinanceSetting";
import React, { useEffect, useState } from 'react';
import { toastr } from "react-redux-toastr";
import CreateLetterEditor from "./CreateLetterEditor";
const EditTemplate = ({
  closeModal,
  type,
  selectedJsonContent,
  editTemplate
}) => {
  const { getAccessTokenSilently } = useAuth0();


  const [jsonContent, setJsonContent] = useState(selectedJsonContent || {});
  const [htmlContent, setHtmlContent] = useState("");
  const [tokenList, setTokenList] = useState([]);

  const buttons = [
    {
      id: "cancel",
      label: "Cancel",
      action: closeModal,
      className: "create-letter__actions-btn cancel",
      variant: "primary-outline",
    },
    {
      id: "save",
      label: "Next",
      action: () => {
        editTemplate({htmlContent, jsonContent})
      },
      className: "create-letter__actions-btn submit",
      variant: "primary",
      // disabled:
      //   enableEdit || previewTemplete
      //     ? false
      //     : (!formik?.values?.useDefault && !formik?.values?.replyTo) || (withSubject && !formik?.values?.subject) ||
      //     formik?.values?.error,
    },
  ];


  const getTemplateTokens = async () => {
    const fileType = type;
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(token, fileType);
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something Went Wrong");
    }
  };


  useEffect(() => {
    getTemplateTokens()
  }, [])

  return (
    <div className="create-letter">
      <div className="create-letter__header">
        <div className="create-letter__header-close" onClick={closeModal}>
          <img src={ChevronIcon} alt="" />
        </div>
        <div className="create-letter__header-close" onClick={closeModal}>
          <img src={closeIcon} alt="" />
        </div>
      </div>
      <hr />
      <div className="create-letter__container">
        <CreateLetterEditor
          setJsonContent={setJsonContent}
          setHtmlContent={setHtmlContent}
          jsonContent={jsonContent}
          tokenList={tokenList}
        />
        <div className="create-letter__actions justify-content-end">
          <>
            {buttons.map((button) => (
              <Button
                className={button.className}
                key={button.id}
                onClick={button.action}
                disabled={button.disabled}
                variant={button.variant}
                size="md"
              >
                {button.loading ? (
                  <div className="d-flex">
                    <CircularProgress
                      size={22}
                      style={{
                        color: "#ffffff",
                      }}
                    />
                  </div>
                ) : (
                  button.label
                )}
              </Button>
            ))}
          </>
        </div>
      </div>
    </div>
  )
}

export default EditTemplate